import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { usePathContext } from '../context/PathContext.js';
import useHandleNextNode from '../hooks/useHandleNextNode.js';
import { useVisitPathGraphFlowMutation } from '../mutations/VisitPathGraphFlow.generated.js';

function usSubmitDryRunCommand() {
  var pathContext = usePathContext();
  var handleNextNode = useHandleNextNode();

  var _useVisitPathGraphFlo = useVisitPathGraphFlowMutation({
    onCompleted: function onCompleted(_ref) {
      var visitPathGraphFlow = _ref.visitPathGraphFlow;

      if (visitPathGraphFlow.error) {
        pathContext.onSetPathGraphFlowErrors(visitPathGraphFlow.error);
        return;
      }

      if (visitPathGraphFlow.pathGraphFlow) {
        handleNextNode({
          pathGraphFlow: visitPathGraphFlow.pathGraphFlow
        });
      }
    }
  }),
      _useVisitPathGraphFlo2 = _slicedToArray(_useVisitPathGraphFlo, 2),
      visitPathGraphFlow = _useVisitPathGraphFlo2[0],
      loading = _useVisitPathGraphFlo2[1].loading;

  return [function () {
    visitPathGraphFlow({
      variables: {
        input: {
          id: pathContext.pathGraphFlowId
        }
      }
    });
  }, {
    loading: loading
  }];
}

export default usSubmitDryRunCommand;
//# sourceMappingURL=useSubmitDryRunCommand.js.map
